<template>
  <!-- 根节点只依赖 extras 存在；formBgWap 相关访问均已守卫，缺失时降级为无背景渲染 -->
  <div
    v-if="extras1"
    class="banner-new"
    :style="{
      background:
        extras1.formBgWap && extras1.formBgWap.colorOrBg == 'color'
          ? extras.formBgWap.color
          : '',
    }"
  >
    <!-- 添加安全检查 -->
    <img
      :src="
        extras1.formBgWap && extras1.formBgWap.colorOrBg == 'src'
          ? extras.formBgWap.src
          : ''
      "
      alt=""
    />

    <div>
      <!-- 添加完整的安全检查链 -->
      <div class="seminar-info" v-if="textSettingWap.display == '1'">
        <!-- 检查BannerText是否存在 -->
        <div
          class="seminar-info-new wap"
          :class="extras1.BannerText && extras1.BannerText.textAlign"
        >
          <div class="content">
            <!-- 为textSettingWap的所有访问添加安全检查 -->
            <div
              class="seminar-title"
              v-if="textSettingWap.subTitleWap != 'hide'"
              :style="{
                color:
                  textSettingWap.subTitleWap == 'custom'
                    ? textSettingWap.subTitleWapFontColor
                    : '',

                'font-size':
                  textSettingWap.subTitleWap == 'custom'
                    ? textSettingWap.subTitleWapFontSize + 'px'
                    : '',
                'font-weight':
                  textSettingWap.subTitleWap == 'custom'
                    ? textSettingWap.subTitleWapFontWeight == 'on'
                      ? '900'
                      : ''
                    : '',
                'font-style':
                  textSettingWap.subTitleWap == 'custom'
                    ? textSettingWap.subTitleWapFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
              }"
            >
              {{ getSubTitleText() }}
            </div>

            <div
              class="seminar-slogan"
              v-if="textSettingWap.titleWap != 'hide'"
              :style="{
                color:
                  textSettingWap.titleWap == 'custom'
                    ? textSettingWap.titleWapFontColor
                    : '',
                'font-size':
                  textSettingWap.titleWap == 'custom'
                    ? textSettingWap.titleWapFontSize + 'px'
                    : '',
                'font-weight':
                  textSettingWap.titleWap == 'custom'
                    ? textSettingWap.titleWapFontWeight == 'on'
                      ? '900'
                      : ''
                    : '',
                'font-style':
                  textSettingWap.titleWap == 'custom'
                    ? textSettingWap.titleWapFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
              }"
            >
              {{
                textSettingWap && textSettingWap.titleWap == "default"
                  ? seminarInfo.title
                  : seminarInfo.title
              }}
            </div>

            <div class="semianr-time">
              <div
                class="_title"
                v-show="textSettingWap.timeTitleWap != 'hide'"
                :style="{
                  color:
                    textSettingWap.timeTitleWap == 'custom'
                      ? textSettingWap.timeTitleWapFontColor
                      : '',
                  'font-size':
                    textSettingWap.timeTitleWap == 'custom'
                      ? textSettingWap.timeTitleWapFontSize + 'px'
                      : '',
                  'font-weight':
                    textSettingWap.timeTitleWap == 'custom'
                      ? textSettingWap.timeTitleWapFontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                  'font-style':
                    textSettingWap.timeTitleWap == 'custom'
                      ? textSettingWap.timeTitleWapFontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'background-color':
                    textSettingWap && textSettingWap.titleBgColorWap
                      ? textSettingWap.titleBgColorWap
                      : 'transparent',
                }"
              >
                {{ getTimeTitleText() }}
              </div>
              <div
                class="_time"
                v-show="textSettingWap.timeWap != 'hide'"
                :style="{
                  color:
                    textSettingWap.timeWap == 'custom'
                      ? textSettingWap.timeWapFontColor
                      : '',
                  'font-size':
                    textSettingWap.timeWap == 'custom'
                      ? textSettingWap.timeWapFontSize + 'px'
                      : '',
                  'font-weight':
                    textSettingWap.timeWap == 'custom'
                      ? textSettingWap.timeWapFontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                  'font-style':
                    textSettingWap.timeWap == 'custom'
                      ? textSettingWap.timeWapFontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'background-color':
                    textSettingWap && textSettingWap.timeBgColorWap
                      ? textSettingWap.timeBgColorWap
                      : 'transparent',
                }"
              >
                {{ getTimeText() }}
              </div>
            </div>
            <div class="semianr-time">
              <div
                class="_title"
                v-show="textSettingWap.addressTitleWap != 'hide'"
                :style="{
                  color:
                    textSettingWap.addressTitleWap == 'custom'
                      ? textSettingWap.addressTitleWapFontColor
                      : '',
                  'font-size':
                    textSettingWap.addressTitleWap == 'custom'
                      ? textSettingWap.addressTitleWapFontSize + 'px'
                      : '',
                  'font-weight':
                    textSettingWap.addressTitleWap == 'custom'
                      ? textSettingWap.addressTitleWapFontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                  'font-style':
                    textSettingWap.addressTitleWap == 'custom'
                      ? textSettingWap.addressTitleWapFontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'background-color':
                    textSettingWap && textSettingWap.titleBgColorWap
                      ? textSettingWap.titleBgColorWap
                      : 'transparent',
                }"
              >
                {{ getAddressTitleText() }}
              </div>
              <div
                class="_time"
                v-show="textSettingWap.addressWap != 'hide'"
                :style="{
                  color:
                    textSettingWap.addressWap == 'custom'
                      ? textSettingWap.addressWapFontColor
                      : '',
                  'font-size':
                    textSettingWap.addressWap == 'custom'
                      ? textSettingWap.addressWapFontSize + 'px'
                      : '',
                  'font-weight':
                    textSettingWap.addressWap == 'custom'
                      ? textSettingWap.addressWapFontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                  'font-style':
                    textSettingWap.addressWap == 'custom'
                      ? textSettingWap.addressWapFontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'background-color':
                    textSettingWap && textSettingWap.addressBgColorWap
                      ? textSettingWap.addressBgColorWap
                      : 'transparent',
                }"
              >
                {{ getAddressText() }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "Banner",
  computed: {
    extras() {
      return this.$store.state.extras;
    },
    extras1() {
      return this.extras;
    },
    textSettingWap() {
      return this.extras1.textSettingWap || this.extras1.textSetting || {};
    },
  },
  props: ["seminarInfo"],
  methods: {
    getSubTitleText() {
      const c = this.textSettingWap;
      const pc = this.extras1.textSetting || {};
      return c.textWap || c.text || pc.text || "";
    },
    getTimeText() {
      const c = this.textSettingWap;
      const pc = this.extras1.textSetting || {};
      const t = c.timeTextWap || c.timeText || pc.timeText;
      return t
        ? t
        : this.handleTimeStamps(
            this.seminarInfo.startTime,
            this.seminarInfo.endTime
          );
    },
    getTimeTitleText() {
      const c = this.textSettingWap;
      const pc = this.extras1.textSetting || {};
      return (
        c.timeTitleTextWap ||
        c.timeTitleText ||
        c.text3 ||
        pc.timeTitleText ||
        this.$t("success.meetingTime")
      );
    },
    getAddressTitleText() {
      const c = this.textSettingWap;
      const pc = this.extras1.textSetting || {};
      return (
        c.addressTitleTextWap ||
        c.addressTitleText ||
        pc.addressTitleText ||
        "会议地点"
      );
    },
    getAddressText() {
      const c = this.textSettingWap;
      const pc = this.extras1.textSetting || {};
      const t = c.addressTextWap || c.addressText || pc.addressText;
      return t ? t : this.seminarInfo.address || "";
    },
    handleTimeStampToDateTime(timeStamp, format) {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var locale = "zh-cn";
      if (lang === "en_US") locale = "en";
      else if (lang === "zh_TW") locale = "zh-tw";
      return moment(timeStamp).locale(locale).format(format);
    },
    handleTimeStamps(startTimeStamp, endTimeStamp) {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var fullFmt, dateFmt, shortDateFmt;
      if (lang === "en_US") {
        fullFmt = "MMM DD, YYYY HH:mm";
        dateFmt = "MMM DD, YYYY";
        shortDateFmt = "MMM DD";
      } else if (lang === "zh_TW") {
        fullFmt = "YYYY年MM月DD日 HH:mm";
        dateFmt = "YYYY年MM月DD日";
        shortDateFmt = "MM月DD日";
      } else {
        fullFmt = "YYYY年MM月DD日 HH:mm";
        dateFmt = "YYYY年MM月DD日";
        shortDateFmt = "MM月DD日";
      }
      let startTimeYear = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY"
      );
      let startDate = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, fullFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, dateFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, shortDateFmt)
        );
      } else {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, dateFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, dateFmt)
        );
      }
    },
  },
};
</script>
